export class CountyResource {
    rid: number;
    name: string;
}